// index.tsx
import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
// import ErrorIcon from "assets/img/errorIcon/icons8-error-100.png"
// import { DatatableProps } from "../../data/interface";

interface DatatableProps {
  columns: any[];
  dataSource: any[];
  rowKeyId?: any;
  Selection?: boolean | undefined;
  handleTableChange?: (pagination: any) => void;
  pagination?: {
    current: number;
    pageSize: number;
    total: number;
  };
  rowKey?: string | ((record: any) => string);
}

const Datatable: React.FC<DatatableProps> = ({
  columns,
  dataSource,
  rowKeyId,
  Selection,
  handleTableChange,
  pagination,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [Selections, setSelections] = useState<any>(true);
  const [filteredDataSource, setFilteredDataSource] = useState<any[]>([]);

  // console.log("pagination in table page", pagination);

  const onSelectChange = (newSelectedRowKeys: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    const filteredData = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDataSource(filteredData);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    return setSelections(Selection); 
  }, [Selection]);
  useEffect(() => {
    setFilteredDataSource(dataSource);
  }, [dataSource]);

  return (
    <>
      <div className="table-top-data">
        <div className="row p-3">
          <div className="col-sm-12 col-md-6">
            <div
              className="dataTables_length"
              id="DataTables_Table_0_length"
            ></div>
          </div>
          <div className="col-sm-12 col-md-6">
            <div
              id="DataTables_Table_0_filter"
              className="dataTables_filter text-end mb-0"
            >
              <label>
                <input
                  type="search"
                  className="form-control form-control-sm"
                  placeholder="Search"
                  aria-controls="DataTables_Table_0"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </label>
            </div>
          </div>
        </div>
      </div>

      {!Selections ? (
        <>
          <Table
            className="table datanew dataTable no-footer"
            columns={columns}
            rowKey={rowKeyId || "ID"}
            rowHoverable={false}
            dataSource={filteredDataSource}
            // pagination={{
            //   locale: { items_per_page: "" },
            //   total: pagination?.total,
            //   defaultPageSize: 10,
            //   showSizeChanger: true,
            //   pageSizeOptions: ["10", "20", "30"],
            //   nextIcon: <i className="ti ti-chevron-right" />,
            //   prevIcon: <i className="ti ti-chevron-left" />,
            // }}
            pagination={{
              current: pagination?.current,
              pageSize: pagination?.pageSize,
              total: pagination?.total,
              locale: { items_per_page: "" },
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "30"],
              showTotal: (total, range) =>
                `Showing ${range[0]} - ${range[1]} of ${total} entries`,
              nextIcon: <i className="ti ti-chevron-right" />,
              prevIcon: <i className="ti ti-chevron-left" />,
            }}
            onChange={handleTableChange}
          />
        </>
      ) : (
        <Table
          className="table datanew dataTable no-footer"
          rowSelection={rowSelection}
          columns={columns}
          rowKey={"ID"}
          rowHoverable={false}
          dataSource={filteredDataSource}
          pagination={{
            total: 100,
            locale: { items_per_page: "" },
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30"],
            showTotal: (total, range) =>
              `Showing ${range[0]} - ${range[1]} of ${total} entries`,
            nextIcon: <i className="ti ti-chevron-right" />,
            prevIcon: <i className="ti ti-chevron-left" />,
          }}
        />
      )}
    </>
  );
};

export default Datatable;

//  <Table
//           className="table datanew dataTable no-footer"
//           rowSelection={rowSelection}
//           columns={columns}
//           rowHoverable={false}
//           dataSource={filteredDataSource}

//           pagination={{
//             locale: { items_per_page: "" },
//             defaultPageSize: 10,
//             showSizeChanger: true,
//             pageSizeOptions: ["10", "20", "30"],
//             showTotal: (total, range) => `Showing ${range[0]} - ${range[1]} of ${total} entries`,
//             nextIcon: <i className="ti ti-chevron-right" />,
//             prevIcon: <i className="ti ti-chevron-left" />,
//           }}
//         />}
